import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=0a8d2360&"
import script from "./Acciones.vue?vue&type=script&lang=ts&"
export * from "./Acciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports